<p-floatlabel class="w-full flex-1 block" [formGroup]="formGroup">
  <textarea pInputTextarea [id]="id" class="w-full" [rows]="4" [attr.placeholder]="placeholder || null"
    [maxlength]="maxLength" [formControlName]="id"
    [autoResize]="resizeable"
    (focusin)="isFocused = true"
  (focusout)="isFocused = false"></textarea>
  <label [for]="id">{{label}} @if (isFocused) {
    <span>({{maxLength - value?.length}})</span>
  }</label>
</p-floatlabel>
@if (formError) {
  <app-form-error [message]="formError"></app-form-error>
}
